import clsx from 'clsx';
import type { HTMLAttributes } from 'react';

import * as styles from './corner-status-pill.css';

export type CornerStatusPillTone = 'neutral' | 'success' | 'warning';

export interface CornerStatusPillProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: CornerStatusPillTone;
}

const TONE_CLASS: Record<CornerStatusPillTone, string> = {
  neutral: styles.cornerStatusPillNeutral,
  success: styles.cornerStatusPillSuccess,
  warning: styles.cornerStatusPillWarning,
};

export function CornerStatusPill({
  className,
  tone = 'neutral',
  ...props
}: CornerStatusPillProps) {
  return (
    <span
      {...props}
      className={clsx(styles.cornerStatusPill, TONE_CLASS[tone], className)}
    />
  );
}
